import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/login.vue'
import Administration from '@/pages/administration.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login
        },
        {
            path: '/administration',
            name: 'administration',
            component: Administration
        },
        // Fallback URL
        {
            path: '*',
            redirect: '/'
        }
    ],
    // Fjerner # fra URL
    mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js